import classNames from "classnames";
import Modal from "components/Modal";
import { FC } from "react";

import ModalRemovePortfolioContent from "./Content";
import styles from "./styles.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  id?: number;
  name?: string;
  assets?: number;
};

const WidgetModalRemovePortfolio: FC<PropTypes> = ({ isVisible, className, id, name, assets }) => {
  return (
    <Modal
      title="Delete portfolio"
      isClose
      isCloseBg
      isVisible={isVisible}
      className={classNames(styles.modal, className)}
    >
      <ModalRemovePortfolioContent id={id} name={name} assets={assets} />
    </Modal>
  );
};

export default WidgetModalRemovePortfolio;
